import { baseUrl } from "../api";

export const textOnlyMessageUrl = `${baseUrl}text-only/`;
